import { defineStore } from 'pinia';
import { type CompanyAccount } from '@/generated/graphql';
import { getCookie } from '@/utils/cookies';
import { Cookie } from '@/constants/storage';

export const useCompanyAccountStore = defineStore('companyAccount', {
	state: () => {
		return {
			currentAccount: undefined as CompanyAccount['id'] | undefined,
		};
	},
	actions: {
		setCurrentAccountFromCookie() {
			const companyAccount = getCookie(Cookie.SAPI_COMPANY_ACCOUNT);
			this.currentAccount = companyAccount;
		},
	},
});
